<template>
 <v-row row wrap>

    <v-col cols="12" sm="6" md="3">
        <v-select
            v-model="selectedCompanyId"
            :items="companies"
            item-text="razonSocial"
            item-value="id"
            :label="$t('admin.company.labels.razonSocial')"
            clearable
            @change="onCompanyChange"
        ></v-select>
    </v-col>

    <v-col cols="12" sm="6" md="3" offset-md="6">
        <search-input  @search="performSearch" v-model="search" />
    </v-col>

    <v-col cols="12">

       <div class="table-fixed-header-wrap">
       <v-data-table
                class="mt-3"
                fixed-header
                height="calc(100vh - 300px)"
                :headers="headers"
                :items="items"
                :search="search"
                :single-expand="false"
                :server-items-length="totalItems"
                :loading="loading"
                :page.sync="pageNumber"
                :items-per-page.sync="itemsPerPage"
                :sort-by.sync="orderBy"
                :sort-desc.sync="orderDesc"
                :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
                @update:page="fetch"
                @update:sort-by="fetch"
                @update:sort-desc="fetch"
                @update:items-per-page="fetch"
        >

            <template slot="no-data">
               <div class="text-xs-center" v-t="'common.noData'"></div>
            </template>

            <template slot="loading">
               <div   class="text-xs-center" v-t="'common.loading'"></div>
            </template>

            <template v-slot:item.company="{ item }">
                {{ item.company ? item.company.razonSocial : '-' }}
            </template>

            <template v-slot:item.permissionsCount="{ item }">
                {{ item.permissions ? item.permissions.length : 0 }}
            </template>

            <template v-slot:item.action="{ item }">
                <edit-button v-if="canEdit" :disabled="isAdminRole(item)" @click="openUpdate(item)" />
                <delete-button v-if="canDelete" :disabled="isAdminRole(item)" @click="openDelete(item)" />
                <v-btn v-if="canCreate" @click="openCopy(item)" icon x-small>
                    <v-icon color="purple">mdi-content-copy</v-icon>
                </v-btn>
            </template>

        </v-data-table>
       </div>
    </v-col>
</v-row>
</template>

<script>
   import InviraRoleProvider from "../../../providers/InviraRoleProvider";
   import CompanyProvider from "../../../providers/CompanyProvider";
   
   import { EditButton, DeleteButton, SearchInput} from "@dracul/common-frontend"
   import { DayjsMixin } from "@dracul/dayjs-frontend";
   import {mapGetters} from "vuex";
    
   
    export default {
        name: "InviraRolesList",
        components: { EditButton, DeleteButton, SearchInput},
        mixins: [DayjsMixin],
        
        data() {
            return {
                items: [],
                totalItems: null,
                loading: false,
                orderBy: 'updatedAt',
                orderDesc: true,
                itemsPerPage: 10,
                pageNumber: 1,
                search: '',
                selectedCompanyId: null,
                companies: []
            }
        },
        computed: {   
          headers () {
            return [
                    //Entity Headers
                    {text: this.$t('admin.inviraRole.labels.name'), value: 'name'},
                    {text: this.$t('admin.company.labels.razonSocial'), value: 'company', sortable: false},
                    {text: this.$t('admin.inviraRole.labels.permissions'), value: 'permissionsCount', sortable: false},
                    //Actions
                    {text: this.$t('common.actions'), value: 'action', sortable: false},
                ]
          },
          getOrderBy(){
              return  (Array.isArray(this.orderBy)) ? this.orderBy[0]: this.orderBy
          },
          getOrderDesc(){
              return  (Array.isArray(this.orderDesc)) ? this.orderDesc[0]: this.orderDesc
          },
          ...mapGetters(['hasPermission']),
          canEdit() {
              return this.hasPermission('ADMIN_INVIRA_ROLE_EDIT')
          },
          canDelete() {
              return this.hasPermission('ADMIN_INVIRA_ROLE_DELETE')
          },
          canCreate() {
              return this.hasPermission('ADMIN_INVIRA_ROLE_CREATE')
          }
        },
        created() {
            this.loadCompanies()
            this.fetch()
        },
        methods:{
            isAdminRole(item) {
                return item && String(item.name || "").toLowerCase() === "admin";
            },
            loadCompanies() {
                CompanyProvider.fetchCompanies()
                    .then(r => {
                        this.companies = r.data.companyFetch || []
                    })
                    .catch(err => console.error(err))
            },
            onCompanyChange() {
                this.pageNumber = 1
                this.fetch()
            },
            performSearch(){
                this.pageNumber = 1
                this.fetch()
            },
            fetch() {
                this.loading = true
                InviraRoleProvider.paginateRoles(
                    this.selectedCompanyId,
                    this.pageNumber, 
                    this.itemsPerPage,
                    this.search,
                    this.getOrderBy, 
                    this.getOrderDesc
                ).then(r => {
                    this.items = r.data.adminInviraRolePaginate.items
                    this.totalItems = r.data.adminInviraRolePaginate.totalItems
                }).catch(err => {
                    console.error(err)
                }).finally(() => this.loading = false)
            },
            openUpdate(role) {
                this.$emit('update', role)
            },
            openCopy(role) {
                this.$emit('copy', role)
            },
            openDelete(role) {
                this.$emit('delete', role)
            }
        }
        
    }
</script>

<style scoped>
.table-fixed-header-wrap {
  min-height: 0;
}
</style>
